import { useEffect, useRef } from 'react'
import { useShortcutsContext } from '../components/KeyboardShortcuts/Shortcuts.context'
import { isAuthenticated } from '../util/authentication'
import { ShortcutsCategories, ShortcutType } from '../components/KeyboardShortcuts/Shortcuts.types'
import { useSelector } from 'react-redux'
import { RootState } from '../store'

const useShortcuts = (category: ShortcutsCategories, shortcuts: ShortcutType, registerFlag=true) => {
    const { registerCategory, unregisterCategory } = useShortcutsContext()
    const storeAuthenticated = useSelector((state: RootState) => state.userStore?.userDetails?.authenticated)
    const authenticated = storeAuthenticated || isAuthenticated()
    const isMobile = useSelector((state: RootState) => state.deviceStore?.isMobile)
    const shouldRegister = registerFlag && !isMobile
    const shortcutsRef = useRef(shortcuts)
    shortcutsRef.current = shortcuts
    const shortcutKeySignature = Object.keys(shortcuts).sort().join('\0')

    useEffect(() => {
        if (!shouldRegister) return

        const shortcutKeys = shortcutKeySignature ? shortcutKeySignature.split('\0') : []
        const wrappedShortcuts: ShortcutType = {}
        shortcutKeys.forEach((key) => {
            wrappedShortcuts[key] = (event: KeyboardEvent) => {
                shortcutsRef.current[key]?.(event)
            }
        })

        if (authenticated) registerCategory(category, wrappedShortcuts)
        return () => {
            unregisterCategory(category, shortcutKeys)
        }
    }, [category, shortcutKeySignature, registerCategory, unregisterCategory, authenticated, shouldRegister])
}

export default useShortcuts
